/**
 * GET/PATCH /control/settings/terminal — the company-wide terminal switches.
 *
 * The PATCH replaces the whole row (like the notification settings next to it),
 * so every field is sent every time; omitting one is a 400 from JSON parsing,
 * not a partial update.
 */
import {requestControl} from '@/shared/api';
import type {CompanyTerminalSettings} from './types';

export function fetchCompanyTerminalSettings(
  companyId: string,
): Promise<CompanyTerminalSettings> {
  return requestControl<CompanyTerminalSettings>(
    '/control/settings/terminal',
    companyId,
  );
}

export function saveCompanyTerminalSettings(
  companyId: string,
  settings: CompanyTerminalSettings,
): Promise<CompanyTerminalSettings> {
  return requestControl<CompanyTerminalSettings>(
    '/control/settings/terminal',
    companyId,
    {method: 'PATCH', body: JSON.stringify(settings)},
  );
}
